module.exports = __webpack_public_path__ + "625a55f677639a71a72576ca81deaabb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/news3.jpg
 ** module id = 518
 ** module chunks = 1
 **/